(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-content-handle="haro-clear-faq"]').forEach(article => {
      const controls = article.querySelector('[data-haro-faq-search]');
      if (!controls || controls.dataset.ready) return;
      const input = controls.querySelector('[data-faq-query]');
      const clear = controls.querySelector('[data-faq-clear]');
      const status = controls.querySelector('[data-faq-status]');
      const empty = controls.querySelector('[data-faq-empty]');
      const groups = [...article.querySelectorAll('[data-haro-faq-list] .haro-faq-group')];
      const items = groups.flatMap(group => [...group.querySelectorAll('details')]);
      const normalize = value => value.toLocaleLowerCase().replace(/[’‘]/g, "'").replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
      const index = new Map(items.map(item => [item, normalize(item.textContent)]));
      function filter() {
        const terms = normalize(input.value).split(/\s+/).filter(Boolean);
        let matches = 0;
        items.forEach(item => {
          const visible = terms.every(term => index.get(item).includes(term));
          item.hidden = !visible;
          if (visible) matches++;
        });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('details')].some(item => !item.hidden); });
        const countTemplate = terms.length
          ? (matches === 1 ? controls.dataset.countOne : controls.dataset.countOther)
          : controls.dataset.countAll;
        status.textContent = (countTemplate || '')
          .replace('__COUNT__', String(terms.length ? matches : items.length))
          .replace('__TOPICS__', String(groups.length));
        empty.hidden = matches !== 0;
        clear.disabled = input.value.length === 0;
      }
      function reset() { input.value = ''; filter(); }
      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
      clear.addEventListener('click', () => { reset(); input.focus(); });
      article.querySelectorAll('.haro-support__topics a').forEach(link => link.addEventListener('click', reset));
      controls.dataset.ready = 'true';
      controls.hidden = false;
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
